import { createContext, useContext } from "react";

export type IntercomContext = {
  show: () => void;
  hide: () => void;
  toggle: () => void;
  showNewMessage: (message: string) => void;
  isBooted: boolean;
};

export const intercomContext = createContext<IntercomContext>({
  show: () => void 0,
  hide: () => void 0,
  toggle: () => void 0,
  showNewMessage: () => void 0,
  isBooted: false,
});

export function useIntercom() {
  const context = useContext(intercomContext);
  return context;
}
